import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterLog } from '@/api/model/interfaces';

export default class RegisterLogOdata extends OdataManager<RegisterLog> {}
